import { ComingSoonPanel, IconFlag } from '@shared/ui';

/**
 * The middle layer: a component groups flags into one thing Product can name
 * and Ops can activate against a museum.
 *
 * Empty on purpose. A flag that exists to be sold is born knowing it — that is
 * what `purpose: entitlement` means on a flag definition — but nothing groups
 * those flags yet, and inventing the grouping here before the catalog defines
 * it would mean guessing what one contains.
 */
export function CatalogComponentsTab() {
    return (
        <ComingSoonPanel
            icon={<IconFlag className="size-6" />}
            title="Components"
            blurb="A component bundles the flags that make up one sellable capability, and is activated against a museum rather than switched. It lands with the activation path that can answer pending."
        />
    );
}
